import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calculator, ArrowRight } from "lucide-react";

interface InstantQuoteCTAProps {
  variant?: 'default' | 'compact' | 'banner';
  className?: string;
}

const InstantQuoteCTA = ({ variant = 'default', className = '' }: InstantQuoteCTAProps) => {
  if (variant === 'compact') {
    return (
      <div className={`text-center ${className}`}>
        <Button 
          asChild 
          className="bg-[#D4A574] hover:bg-[#C49A6C] text-black font-semibold px-6 py-3"
        >
          <Link to="/request-quote" className="flex items-center gap-2">
            <Calculator className="w-5 h-5" />
            Get Instant Quote
            <ArrowRight className="w-4 h-4" />
          </Link>
        </Button>
      </div>
    );
  }

  if (variant === 'banner') {
    return (
      <section className={`bg-gradient-to-r from-[#1F2937] to-[#374151] border-y border-[#D4A574]/30 py-8 ${className}`}>
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white mb-1">Need a Quick Price Estimate?</h3>
              <p className="text-gray-400">Get an instant fare quote in seconds — no phone calls needed!</p>
            </div>
            <Button 
              asChild 
              size="lg"
              className="bg-[#D4A574] hover:bg-[#C49A6C] text-black font-semibold px-8 whitespace-nowrap"
            >
              <Link to="/request-quote" className="flex items-center gap-2">
                <Calculator className="w-5 h-5" />
                Get Instant Quote
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    );
  }

  // Default variant - full section
  return (
    <section className={`py-16 bg-[#0a0a0a] ${className}`}>
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-2xl mx-auto">
          <div className="w-16 h-16 bg-[#D4A574]/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Calculator className="w-8 h-8 text-[#D4A574]" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Get Your Instant Quote
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            Use our fare calculator to get an accurate price estimate in seconds. 
            No waiting, no phone calls required. All prices include 20% gratuity.
          </p>
          <Button 
            asChild 
            size="lg"
            className="bg-[#D4A574] hover:bg-[#C49A6C] text-black font-semibold px-10 py-6 text-lg"
          >
            <Link to="/request-quote" className="flex items-center gap-2">
              <Calculator className="w-5 h-5" />
              Calculate Your Fare Now
              <ArrowRight className="w-5 h-5" />
            </Link>
          </Button>
          <p className="text-gray-500 text-sm mt-4">
            Luxury 2025 Audi Q7 SUV • Professional Chauffeur • 24/7 Service
          </p>
        </div>
      </div>
    </section>
  );
};

export default InstantQuoteCTA;
